import { queries } from "@evertrue/vms-insights";

const CONTACTS_BY_NAME_WITH_ASSIGNMENTS_QUERY = (name, poolIds, hasNoUser) => {
  const contacts_query = queries.SOLICITORS_BY_NAME_QUERY(name, poolIds ? poolIds : undefined);

  // scopes contact query down to contacts to are users
  const is_user_part = {
    identities: {
      instance: {
        type: {
          match: 4,
        },
        value: {
          exists: true,
        },
      },
    },
  };
  if (hasNoUser) {
    contacts_query.must_not = [is_user_part];
  } else {
    contacts_query.must.push(is_user_part);
  }

  return contacts_query;
};

export default {
  CONTACTS_BY_NAME_WITH_ASSIGNMENTS_QUERY,
};
